<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">公共账号管理</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>账户余额</el-breadcrumb-item>
    </el-breadcrumb>

    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-select
          v-model="userType"
          size="mini"
          placeholder="公户类型"
          clearable
          filterable
          style="width: 200px"
        >
          <el-option
            v-for="item in typeOptions"
            :key="item.code"
            :label="item.name"
            :value="item.code"
          />
        </el-select>
        <el-select v-model="coin" size="mini" placeholder="币种" filterable style="width: 120px">
          <el-option v-for="item in coinOptions" :key="item" :label="item" :value="item" />
        </el-select>
        <el-button size="mini" type="primary" @click="handleSearch">搜索</el-button>
        <span v-if="tableRows.length" class="balance-total">
          总余额
          <strong :class="amountClass(totalBalance)">{{ formatAmount(totalBalance) }}</strong>
          {{ coin }}
        </span>
      </div>

      <el-table :data="tableRows" style="width: 100%" min-height="500">
        <el-table-column prop="userTypeName" label="公户类型" min-width="140" header-align="left" align="left" />
        <el-table-column prop="userId" label="公户UID" width="120" header-align="left" align="left" />
        <el-table-column prop="tenantUserId" label="租户UID" width="120" header-align="left" align="left" />
        <el-table-column prop="coin" label="币种" width="100" header-align="left" align="left" />
        <el-table-column prop="amount" label="余额" min-width="140" header-align="left" align="left">
          <template slot-scope="scope">
            <span
              :class="['clickable-amount', amountClass(scope.row.amount)]"
              @click="openDetail(scope.row)"
            >
              {{ formatAmount(scope.row.amount) }}
            </span>
          </template>
        </el-table-column>
        <el-table-column prop="remark" label="备注" min-width="120" show-overflow-tooltip header-align="left" align="left" />
      </el-table>
    </el-card>

    <account-bill-detail-dialog ref="detailDialog" />
  </div>
</template>

<script>
import api from './api';
import AccountBillDetailDialog from './components/AccountBillDetailDialog';
import { DEFAULT_COIN, loadCoinOptions } from '../common/coins';

export default {
  name: 'PublicAccountBalance',
  components: {
    AccountBillDetailDialog,
  },
  data() {
    return {
      userType: null,
      coin: DEFAULT_COIN,
      coinOptions: [DEFAULT_COIN],
      typeOptions: [],
      tableRows: [],
    };
  },
  computed: {
    totalBalance() {
      return this.tableRows.reduce((sum, row) => sum + (Number(row.amount) || 0), 0);
    },
  },
  mounted() {
    Promise.all([this.loadTypes(), loadCoinOptions()]).then(([, coins]) => {
      this.coinOptions = coins;
      if (!this.coinOptions.includes(this.coin)) {
        this.coin = DEFAULT_COIN;
      }
      this.handleSearch();
    });
  },
  methods: {
    formatAmount(value) {
      if (value === null || value === undefined || value === '') return '0';
      return String(value);
    },
    amountClass(value) {
      return Number(value) >= 0 ? 'amount-positive' : 'amount-negative';
    },
    loadTypes() {
      return api.types().then((res) => {
        if (res.code === 0) {
          this.typeOptions = res.data || [];
        }
      });
    },
    fetchList() {
      api.list({ userType: this.userType, coin: this.coin }).then((res) => {
        if (res.code === 0) {
          this.tableRows = res.data || [];
        }
      });
    },
    handleSearch() {
      this.fetchList();
    },
    openDetail(row) {
      this.$refs.detailDialog.open(row, this.coin);
    },
  },
};
</script>

<style scoped>
.page-actions {
  display: flex;
  gap: 8px;
  align-items: center;
  margin-bottom: 16px;
  flex-wrap: nowrap;
}

.balance-total {
  margin-left: auto;
  font-size: 13px;
  color: #606266;
  white-space: nowrap;
}

.balance-total strong {
  margin: 0 4px;
  font-size: 15px;
}

.clickable-amount {
  cursor: pointer;
}

.clickable-amount:hover {
  text-decoration: underline;
}

.amount-positive {
  color: #67c23a;
}

.amount-negative {
  color: #f56c6c;
}
</style>
